import _includes from 'lodash/includes';
import type {
  WCmsHomepageSectionView,
  WCmsVideoView,
  WCmsPhotoView,
} from '@zola/svc-web-api-ts-client';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import { entityNames } from 'actions/PublicWebsiteActions';

const filterByEntityType = (type: string, entity: GenericEntityType) => {
  switch (type) {
    case entityNames.home:
      return entity.title && entity;
    case entityNames.photos:
      return entity.image_id && entity;
    case entityNames.videos:
      return entity.url && entity;
    default:
      return entity;
  }
};

const filterEntities = (entitiesById: Record<number, GenericEntityType>, type: string) => {
  return Object.entries(entitiesById).filter(([, entity = {}]) => filterByEntityType(type, entity));
};

export const filterEntitiesById = (
  entitiesById: Record<number, GenericEntityType>,
  type: string
): Record<number, WCmsPhotoView | WCmsHomepageSectionView | WCmsVideoView> =>
  Object.fromEntries(filterEntities(entitiesById, type));

export const filterEntitiesOrderedIds = (
  orderedIds: number[],
  entitiesById: Record<number, GenericEntityType>,
  type: string
): number[] => {
  const filtered = filterEntities(entitiesById, type)
    .flat()
    .filter(item => typeof item === 'string')
    .map(key => Number(key));
  return orderedIds.filter(id => _includes(filtered, id));
};

export const filterPhotos = (entity?: WCmsPhotoView): boolean => !!entity?.image_id;

export const filterVideos = (entity?: WCmsVideoView): boolean => !!entity?.external_video_id;

export const filterStories = (entity?: WCmsHomepageSectionView): boolean => !!entity?.title;

export default {
  filterEntitiesById,
  filterEntitiesOrderedIds,
};
